import ChartJS from "chart.js/auto"
import {
  BarElement,
  CategoryScale,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js"
import { Bar } from "react-chartjs-2"
import { useEffect, useState } from "react"
import axios from "axios"
import { useSelector } from "react-redux"
import { getConf } from "../../../store/features/confSlice"
import { Button, Grid } from "@mui/material"
import saveAs from "file-saver"
import { getAuth } from "../../../store/features/authSlice"

/**
 * Tipo: Horizontal Bars
 * Detalle: Muestra la cantidad de usuarios role 2 (Usuario de app) registrados en la app por cada capítulo
 */

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export const UsersForChapterChart = () => {
  const conf = useSelector(getConf)
  const auth = useSelector(getAuth)
  const [report, setReport] = useState([])
  const [isLoading, setLoading] = useState(true)
  const title = "Usuarios registrados en el app por capítulo"

  useEffect(() => {
    getReport()
  }, [])

  const getReport = async () => {
    try {
      const endpoint = `/report/chart/users-for-chapter`
      const { data } = await axios.get(API_ROUTE + endpoint, {
        headers: { Authorization: auth.data.jwtToken },
      })
      setReport(data)
      console.table(data)
      setLoading(false)
    } catch (err) {
      console.log(err)
      console.log("No se pudo obtener los datos del reporte")
    }
  }

  const download = () => {
    const head = "código de capítulo;capítulo;usuarios\n"
    const body = report
      .map((item) => {
        const chapterId = item.chapter
        const chapter = conf.data.chapters.find((e) => e.id === chapterId).name
        const users = item.users
        return chapterId + ";" + chapter + ";" + users
      })
      .join("\n")
    const file = new Blob([head + body])
    saveAs(file, `${Date.now()}.txt`)
  }

  if (isLoading) return <></>

  const options = {
    indexAxis: "y",
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: true,
        text: title,
      },
    },
  }

  const data = {
    labels: report.map(
      (item) => conf.data.chapters.find((e) => e.id === item.chapter).name
    ),
    datasets: [
      {
        label: "Cantidad de usuarios",
        data: report.map((item) => item.users),
        backgroundColor: conf.data.colors
          .filter((_, index) => index > 0)
          .map((item) => item.bg),
        borderWidth: 1,
      },
    ],
  }

  return (
    <>
      <Bar options={options} data={data} />
      <Grid container spacing={1} my={1}>
        <Grid item xs={12}>
          <Button
            fullWidth
            variant="outlined"
            size="large"
            sx={{ height: 55 }}
            onClick={download}
          >
            Descargar
          </Button>
        </Grid>
      </Grid>
    </>
  )
}
